<template>
	<div class="home">
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<NavHead></NavHead>
		<!-- 服务列表 -->
		<div style="background-color: #f8f8f8;">
			<div class="serviceList">
				<!-- 导航列表 -->
				<div class="navList">
					<ul>
						<li v-for="(item,index) in navList" :key="index" :class="{'activeBg':index == activeIndex}"
							@click="AIndex(index)">
							{{item.name}}
						</li>
					</ul>
				</div>
				<!-- 列表详情 -->
				<div class="listDesc">
					<!-- 列表加载骨架屏 -->
					<el-skeleton style="width: 278px;" :loading="listLoading">
						<template #template>
							<div style="border: 1px solid #eee;margin:20px;">
								<div class="d-flex" style="justify-content: space-between;align-items: center;
								border-bottom: 1px dashed #eee;">
									<el-skeleton-item variant="image" style="width:278px; height: 100px" />
								</div>
								<div class="mt-2" style="width: 278px;height: 50px;">
									<div>
										<el-skeleton-item variant="text" style="width:50px;margin: 10px;"/>
										<el-skeleton-item variant="text" style="width:100px;margin: 10px;margin-left: 50px;"/>
									</div>
								</div>
							</div>
						</template>
						<template #default>
							<div class="mt-4 ml-4 mb-2">
								<!-- 卡片列表 -->
								<serviveCard v-for="(item,index) in serviceList" :key="index" :topName="item.name" :price="item.chargeAmount"
									border style="display: inline-block;margin-right:13px;" :logoUrl="item.logoUrl">
									<span class="contentBtn" 
									@click="goDetailLink(item.id,item.baseServeType,`/serviceList?index=${this.activeIndex}`)">
										查看详情
									</span>
								</serviveCard>
								<el-empty description="暂无数据哦~" v-show="serviceList.length == 0"></el-empty>
							</div>
						</template>
					</el-skeleton>
				</div>
				<!-- 分页器 -->
				<div style="text-align: center;margin-bottom:25px;" class="pt-4 py-4">
					<el-pagination background layout="prev, pager, next"
					@current-change="getserviceList" :current-page="paging.currPage"
					:page-size="paging.everySize" :total="paging.allNum">
					</el-pagination>
				</div>
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer :bgColor="'#fafafa'" :border="true"></Footer>
		</div>
	</div>
</template>

<script>
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import serviveCard from '@/components/showCard/serviceCard.vue'
	import Footer from '@/components/footer/footer.vue'
	export default {
		name: 'Home',
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			serviveCard,
			Footer
		},
		data() {
			return {
				navList: [{
						name: '全部服务',
						type: 'all'
					},
					{
						name: '专利服务',
						type: 'patent'
					},
					{
						name: '商标服务',
						type: 'trademark'
					},
					{
						name: '版权服务',
						type: 'copyright'
					},
					{
						name: '贯标服务',
						type: 'iso'
					},
					{
						name: '项目服务',
						type: 'project'
					},
				],
				activeIndex:0,
				activeName:'',
				listLoading: false,
				serviceList: [],
				paging: {currPage: 1, everySize: 12, allNum: 0},
				//检索条件
				condition: {
					type:''
				}
			}
		},
		mounted() {
			let vm = this
			if(vm.$route.query.index){
				vm.AIndex(vm.$route.query.index)
			}else{
				vm.activeIndex = window.sessionStorage.getItem('basicServiceIndex')
			}
			this.getserviceList()
		},
		watch: {

		},
		methods: {
			// 进入商品详情页
			goDetailLink(id,mbx,mbxLink){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:'base'
					}
				})
				window.open(routeData.href, '_blank');
			},
			getserviceList(currentPage) {
				let vm = this
				vm.listLoading = true
				// 区分分页与查询
				if(currentPage){
				   vm.paging.currPage = currentPage;
				} else {
				   vm.paging.currPage = 1;
				} 
				var params = {}
				params.currPage = vm.paging.currPage
				params.everySize = vm.paging.everySize
				params.type = vm.condition.type
				this.axios.get('/api/base/serve/findAllByPage', {params:params}).then(res => {
					vm.serviceList = res.data.data.baseServes
					vm.paging = res.data.data.pagingBean
					vm.listLoading = false
				})
			},
			AIndex(index) {
				let vm = this
				vm.activeIndex = index
				if(vm.navList[index].name == "全部服务"){
					vm.condition.type = ''
				}else{
					vm.condition.type = vm.navList[index].name
				}
				vm.$store.commit('activeBasicService',index)
				vm.$router.push({
					path:'/serviceList',
					query:{
						index
					}
				})
				this.getserviceList()
			}
		},
	}
</script>
<style scoped>
	.serviceList {
		width: 1200px;
		margin: 0 auto;
		overflow: hidden;
	}

	.serviceList .navList {
		width: 1200px;
		height: 70px;
	}

	.serviceList .navList ul {
		line-height: 70px;
		position: relative;
		left: -20px;
	}

	.activeBg {
		background-color: #c32a1a;
		color: #fff;
	}

	.serviceList .navList ul li {
		display: inline-block;
		width: 100px;
		height: 36px;
		line-height: 36px;
		text-align: center;
		margin-right: 20px;
		border-radius: 5px;
		cursor: pointer;
	}

	/* 列表展示详情 */
	.serviceList .listDesc {
		width: 1200px;
		min-height:500px;
		background-color: #fff;
		display: inline-block;
		margin-top:5px;
		margin-bottom:5px;
	}
	/* 查看详情 */
	.contentBtn{
		width: 60px;
		margin-right: 10px;
		color: #999;
		cursor: pointer;
		font-size: 14px;
	}
	.contentBtn:hover{
		color: #C32A1A;
	}
</style>
<style>
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #C32A1A;
	}
</style>

